import { encodeQuery } from 'Helpers/Query';
import {
  householdId,
  currentFile,
  modal,
  files as filesConst,
} from 'Consts/Queries';

export const rootUri = '';
export const loginUri = `${rootUri}/login`;

export const forgotPasswordUri = `${rootUri}/forgot-password`;

export const scheduleIntroHref = 'https://facetwealth.com/get-started/';

export const planPreviewUri = (householdID, planID) => `/preview/household/${householdID}/plan/${planID}`;

const baseStaticUrl = 'https://static.facetwealth.com/';

export const staticImageUrl = `${baseStaticUrl}image/`;
export const staticAppUrl = `${baseStaticUrl}app`;

export const householdSecureFilesPreviewUri = (hhId, files, currentQueries = {}) => encodeQuery({
  [householdId]: hhId,
  [currentFile]: files[0],
  [modal]: 'fileViewer',
  // I am not sure why currentQueries is being spread this far down in the list, I would have expected it to go earlier.
  // I am leaving it the way it is now in case there is some code relying on this behavior.
  ...currentQueries,
  [filesConst]: files,
});

export const logoUrl = `${baseStaticUrl}logo.png`; // just the company logo
export const facetLogoUrl = 'https://static.facetwealth.com/app/icons/brand/facet_logo_rgb.svg'; // company logo with company name
export const facetLogoHorizontalUrl = `${baseStaticUrl}app/icons/facet-logo.svg`;

// FQ lives on a couple of different domains -- the WP domain and the FQ domain (app.facet.com)
// We need to know which domain we're on to send the api requests via the right base url
const getConfig = () => {
  const { origin } = window.location;

  if (origin === process.env.REACT_APP_WP_APP_URL) {
    return {
      appUrl: process.env.REACT_APP_WP_APP_URL,
      apiUrl: process.env.WP_API_URL,
    };
  }
  if (origin === process.env.REACT_APP_FQ_APP_URL) {
    return {
      appUrl: process.env.REACT_APP_FQ_APP_URL,
      apiUrl: process.env.FQ_API_URL,
    };
  }

  return {
    appUrl: process.env.REACT_APP_APP_URL,
    apiUrl: process.env.API_URL,
  };
};

export const GetAppUrl = () => getConfig().appUrl;

export const getAPIURL = () => getConfig().apiUrl;
